module.exports = __webpack_public_path__ + "static/media/bg-home-bottom-left.6c0bdb0c.png";